<wsd-extended-card
  [loading]="!(annualReporting$ | async)"
  [redirectTo]="['/organizations', organizationId, 'modify', 'reporting']"
  [title]="'DATA_PORTAL.ANNUAL_REPORTING.TITLE' | translate">

  <div *ngIf=" (annualReporting$ | async) as data ">
    <wsd-report
      *gsShowIfHasPermission="['NDP_ORGANIZATION_ANNUAL_REPORT_READ']"
      [title]="'DATA_PORTAL.ANNUAL_REPORTING.ANNUAL_REPORT' | translate"
      [organizationId]="organizationId"
      [fileId]="data.annualReportFileId"
      [date]="data.annualReportLastUpdateDate"
      [year]="data.annualReportYear">
    </wsd-report>
    <div *ngIf="!groupAdminView">
      <wsd-report
        *gsShowIfHasPermission="['NDP_ORGANIZATION_FINANCIAL_REPORT_READ']"
        [date]="data.financialStatementLastUpdateDate"
        [fileId]="data.financialStatementFileId"
        [organizationId]="organizationId"
        [title]="'DATA_PORTAL.ANNUAL_REPORTING.ANNUAL_FINANCIAL_STATEMENT' | translate"
        [year]="data.financialStatementYear">
      </wsd-report>
    </div>
    <div *ngIf="groupAdminView">
      <wsd-report
        [date]="data.financialStatementLastUpdateDate"
        [fileId]="data.financialStatementFileId"
        [organizationId]="organizationId"
        [title]="'DATA_PORTAL.ANNUAL_REPORTING.ANNUAL_FINANCIAL_STATEMENT' | translate"
        [year]="data.financialStatementYear">
      </wsd-report>
    </div>

  </div>
</wsd-extended-card>
